const Auth = {
	logout() {
		this.token = false;
	}
};
export default Auth;
